import React from 'react'

export default function Footer() {
    return (
        <>
            <footer className="unslate_co--footer unslate_co--section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-7">
                            <div className="footer-site-logo"><a href="portfolio-section">Bobbie Arts<span>.</span></a></div>
                            <ul className="footer-site-social">
                                <li><a href="https://web.facebook.com/bobby.izuka">Facebook</a></li>
                                <li><a href="https://twitter.com/B_o_b_b_1_E">Twitter</a></li>
                                <li><a href="https://www.instagram.com/offixial_bobbie/">Instagram</a></li>
                            </ul>
                            <p className="site-copyright">
                                {/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}
                                Bobbie Arts
                                {/* All rights reserved | This template is made with <i className="icon-heart" aria-hidden="true" /> by <a href="https://colorlib.com" target="_blank">Colorlib</a> */}
                                {/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}
                            </p>
                        </div>
                    </div>
                </div>
            </footer>

        </>
    )
}
